/**
 * 站点关键词编辑器组件
 * 用于编辑不同 Amazon 站点的核心关键词
 */

import React from 'react';
import { Collapse, Space, Tag, Input } from 'antd';

// 站点选项
export const SITE_OPTIONS = [
    { value: 'US', label: '美国站 (US)' },
    { value: 'UK', label: '英国站 (UK)' },
    { value: 'DE', label: '德国站 (DE)' },
    { value: 'FR', label: '法国站 (FR)' },
    { value: 'IT', label: '意大利站 (IT)' },
    { value: 'ES', label: '西班牙站 (ES)' },
    { value: 'JP', label: '日本站 (JP)' },
];

export interface SiteKeywordsEditorProps {
    value?: Array<{ site: string; keywords: string }>;
    onChange?: (value: Array<{ site: string; keywords: string }>) => void;
}

export const SiteKeywordsEditor: React.FC<SiteKeywordsEditorProps> = ({ value = [], onChange }) => {
    // 将数组转换为 Record 格式便于编辑
    const keywordsMap: Record<string, string> = {};
    value.forEach(item => {
        if (item.site) {
            keywordsMap[item.site] = item.keywords || '';
        }
    });

    // 更新某个站点的关键词
    const handleSiteKeywordsChange = (siteCode: string, keywords: string) => {
        const newMap = { ...keywordsMap, [siteCode]: keywords };
        // 转换回数组格式
        const newValue = Object.entries(newMap)
            .filter(([_, kw]) => kw.trim())
            .map(([site, kw]) => ({ site, keywords: kw }));
        onChange?.(newValue);
    };

    // 统计各站点已填写的关键词数量
    const getKeywordCount = (siteCode: string) => {
        const kw = keywordsMap[siteCode] || '';
        if (!kw.trim()) return 0;
        return kw.split(',').filter(k => k.trim()).length;
    };

    return (
        <Collapse
            size="small"
            items={SITE_OPTIONS.map(site => ({
                key: site.value,
                label: (
                    <Space>
                        <Tag>{site.value}</Tag>
                        {site.label.replace(` (${site.value})`, '')}
                        {getKeywordCount(site.value) > 0 && (
                            <Tag color="green">{getKeywordCount(site.value)} 个关键词</Tag>
                        )}
                    </Space>
                ),
                children: (
                    <Input.TextArea
                        value={keywordsMap[site.value] || ''}
                        onChange={e => handleSiteKeywordsChange(site.value, e.target.value)}
                        placeholder={`输入 ${site.label} 的核心关键词，用逗号分隔`}
                        autoSize={{ minRows: 2, maxRows: 4 }}
                    />
                ),
            }))}
        />
    );
};

export default SiteKeywordsEditor;
